import { useEffect, useState } from "react";
import { getService, PostService } from "../GenericServices/genericService";
import Swal from "sweetalert2";
import { resources_EN } from "../GenericServices/componentUtils";

const AdminOrders = ({
  updateOrder,
  setViewingOrder,
  setShowOrderModal,
  deleteOrder,
}) => {
  const [orderData, setOrderData] = useState([]);
  const [orderStatus, setOrderStatus] = useState([]);
  // pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    getOrderAPI();
    getOrderStatusAPI();
  }, []);

  /* Get Order API */
  const getOrderAPI = () => {
    const url = "myNewAPI/get_orders.php";
    getService(url, {}, getOrderData);
    console.log("orderData", orderData);
  };

  /* Set Order Data */
  const getOrderData = (response) => {
    console.log("Response", response);
    setOrderData(response.orders);
    // do not reset currentPage here; otherwise changing a status or re-fetching
    // will jump the table back to page 1 and interrupt dropdown interaction.
  };

  /* Get Order Status */
  const getOrderStatusAPI = () => {
    const url = "myNewAPI/get_order_status.php";
    getService(url, {}, getOrderStatusData);
  };

  const getOrderStatusData = (response) => {
    setOrderStatus(response.order_status);
  };

  /* Update Order API */
  const updateOrderAPI = (orderId, data) => {
    const url = "myNewAPI/update_order.php";
    const payload = { order_id: orderId, status_id: data.status };
    PostService(url, payload, modal);
  };

  /* Error or Success Modal */
  const modal = (icon, title, message, response = "") => {
    Swal.fire({
      title: title,
      icon: icon,
      text: message,
    }).then((resp) => {
      if (resp.isConfirmed && icon === resources_EN.success) {
        getOrderAPI();
      }
    });
  };

  /* COnfirmation of Delete Order */
  const confirmDeleteOrder = (orderId) => {
    Swal.fire({
      title: "Delete Order",
      text: "Are you sure you want to delete this order?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      confirmButtonColor: "#d33",
      icon: "warning",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteOrderAPI(orderId);
      }
    });
  };

  /* Delete Order API */
  const deleteOrderAPI = (orderId) => {
    const url = "myNewAPI/delete_order.php";
    const data = { order_id: orderId };
    PostService(url, data, modal);
  };

  const pagedOrders = orderData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <>
      {/* ── Desktop Table (hidden on mobile) ── */}
      <div className="hidden sm:block bg-white shadow overflow-hidden sm:rounded-md">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Items</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {pagedOrders.map((order, index) => (
              <tr key={order.order_id}>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {(currentPage - 1) * pageSize + index + 1}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{order.customer_name}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{order.total_items} item(s)</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  PKR {new Intl.NumberFormat("en-IN").format(order.total)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  <select
                    value={order.status_id}
                    onChange={(e) => updateOrderAPI(order.order_id, { status: e.target.value })}
                    className="border border-gray-300 rounded px-2 py-1"
                  >
                    {orderStatus.map((status) => (
                      <option key={status.id} value={status.id}>{status.status_name}</option>
                    ))}
                  </select>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {new Date(order.created_at).toLocaleDateString()}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button
                    onClick={() => { setViewingOrder(order); setShowOrderModal(true); }}
                    className="text-blue-600 hover:text-blue-900 mr-4"
                  >
                    View
                  </button>
                  <button
                    onClick={() => confirmDeleteOrder(order.order_id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ── Mobile Cards (hidden on sm+) ── */}
      <div className="sm:hidden space-y-3">
        {pagedOrders.map((order, index) => (
          <div key={order.order_id} className="bg-white shadow rounded-lg p-4">
            {/* Card header */}
            <div className="flex justify-between items-center mb-3">
              <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider">
                #{(currentPage - 1) * pageSize + index + 1}
              </span>
              <span className="text-xs text-gray-400">
                {new Date(order.created_at).toLocaleDateString()}
              </span>
            </div>

            {/* Customer & items */}
            <div className="mb-3">
              <p className="text-sm font-semibold text-gray-900">{order.customer_name}</p>
              <p className="text-sm text-gray-500">{order.total_items} item(s)</p>
            </div>

            {/* Total */}
            <div className="mb-3">
              <span className="text-xs text-gray-400 uppercase tracking-wider">Total</span>
              <p className="text-sm font-medium text-gray-900">
                PKR {new Intl.NumberFormat("en-IN").format(order.total)}
              </p>
            </div>

            {/* Status dropdown */}
            <div className="mb-4">
              <span className="text-xs text-gray-400 uppercase tracking-wider block mb-1">Status</span>
              <select
                value={order.status_id}
                onChange={(e) => updateOrderAPI(order.order_id, { status: e.target.value })}
                className="w-full border border-gray-300 rounded px-2 py-1.5 text-sm"
              >
                {orderStatus.map((status) => (
                  <option key={status.id} value={status.id}>{status.status_name}</option>
                ))}
              </select>
            </div>

            {/* Actions */}
            <div className="flex gap-2 pt-3 border-t border-gray-100">
              <button
                onClick={() => { setViewingOrder(order); setShowOrderModal(true); }}
                className="flex-1 py-1.5 text-sm text-center text-blue-600 border border-blue-200 rounded hover:bg-blue-50"
              >
                View
              </button>
              <button
                onClick={() => confirmDeleteOrder(order.order_id)}
                className="flex-1 py-1.5 text-sm text-center text-red-600 border border-red-200 rounded hover:bg-red-50"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* ── Pagination ── */}
      <div className="mt-4 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="text-sm text-gray-700">
          Showing{" "}
          <span className="font-medium">{(currentPage - 1) * pageSize + 1}</span>{" "}
          to{" "}
          <span className="font-medium">{Math.min(currentPage * pageSize, orderData.length)}</span>{" "}
          of <span className="font-medium">{orderData.length}</span> results
        </div>
        <div className="flex items-center space-x-2">
          <select
            value={pageSize}
            onChange={(e) => { setPageSize(Number(e.target.value)); setCurrentPage(1); }}
            className="border border-gray-300 rounded px-2 py-1 text-sm"
          >
            {[5, 10, 20, 50].map((size) => (
              <option key={size} value={size}>{size} / page</option>
            ))}
          </select>
          <button
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            disabled={currentPage === 1}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            Prev
          </button>
          <button
            onClick={() => setCurrentPage((p) => Math.min(p + 1, Math.ceil(orderData.length / pageSize)))}
            disabled={currentPage >= Math.ceil(orderData.length / pageSize)}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
};

export default AdminOrders;
